import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolAction } from '../symbol.action';
import { SymbolTranslator } from '../symbol.translator';

type IDependencies = IClientApiDependencySegment;

export const loadSymbolEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolAction.load.started),
  switchMap((params) => {
    return dependencies.api.getSymbolDetails(params).pipe(
      mergeMap((response) => {
        return [
          SymbolAction.load.done({ params, result: SymbolTranslator.fromApiDetails(response) }),
        ];
      }),
      catchApiError((error) => {
        return [
          SymbolAction.load.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
